import { compose, filter, map, pathEq, propOr, includes, __, toLower, prop } from 'ramda'
import { useFilter } from '@btime/react-contexts'
import React from 'react'

import FiltersGroup from '../../../components/filter/FiltersGroup'
import LevelsLoader, { useEnabledLevels } from '../_load/LevelsLoader'
import PlaceLevelsFilter from './PlaceLevelsFilter'
import PlacesFilter from './PlacesFilter'

const FilterItem = ({ isLast, level, type, parentLevel, placesField, placeLevelsField }) => {
  placeLevelsField = placeLevelsField || 'placeLevelIds'
  placesField = placesField || 'placeIds'

  const filters = useFilter()
  const parentIds = compose(
    map(prop('value')),
    filter(
      item =>
        pathEq(['origin', 'level', 'id'], prop('id', parentLevel), item) && pathEq(['origin', 'placeType'], type, item)
    )
  )(filters[placeLevelsField] || [])

  const commonProps = { parentIds, type, label: level.name }

  // TODO: Opção de esconder
  if (isLast) return <PlacesFilter presentation="list" field={placesField} {...commonProps} />

  return <PlaceLevelsFilter presentation="list" field={placeLevelsField} {...commonProps} levelId={level.id} />
}

const DEFAULT_LEVELS_NAMES = ['level 01', 'level 02', 'level 03', 'level 04']
const PlacesFilterGroupsItems = ({ label, type, ...props }) => {
  const levels = useEnabledLevels()

  const hideFilter = levels.every(compose(includes(__, DEFAULT_LEVELS_NAMES), toLower, propOr('', 'name')))
  if (hideFilter) return false

  return (
    <FiltersGroup label={label}>
      {levels.map((level, index) => (
        <FilterItem
          key={level.id}
          isLast={levels.length - 1 === index}
          level={level}
          type={type}
          parentLevel={levels[index - 1]}
          {...props}
        />
      ))}
    </FiltersGroup>
  )
}

const Wrapper = ({ type, ...props }) => {
  return (
    <LevelsLoader type={type}>
      <PlacesFilterGroupsItems type={type} {...props} />
    </LevelsLoader>
  )
}

export default Wrapper
